import { Component, Input, OnInit } from '@angular/core';
import { Form, FormElement } from 'src/common/form';
import { TranslationManager } from 'src/common/translation';
import { TranslationEntity } from './translation-entity.model';

@Component({
  selector: 'translation-entity',
  templateUrl: './translation-entity.component.html'
})
export class TranslationEntityComponent implements OnInit {

	translationManager = TranslationManager;
	form: Form = new Form();

	@Input() uniqueIdentifier: string;

	ngOnInit(): void {
		if (this.uniqueIdentifier) {
			for (let language of TranslationManager.languages?.languages) {
				this.form.elements[language.culture] = new FormElement();
				this.form.elements[language.culture].state.mandatory = true;
			}
		}
	}

	isValid(): boolean {
		return this.form.isValid();
	}

	set entity(val: TranslationEntity) {
		if (val && val.items) {
			val.items.forEach(s => {
				if (TranslationManager.languages?.languages.find(l => l.culture === s.culture)) {
					this.form.elements[s.culture].value = s.translation;
				}
			})
		}
	}

	get entity(): TranslationEntity {

		let translationEntity: TranslationEntity = new TranslationEntity();

		translationEntity.key = this.uniqueIdentifier;
		translationEntity.items = [];

		for (let language of TranslationManager.languages?.languages) {
			translationEntity.items.push({
				culture: language.culture,
				translation: this.form.elements[language.culture].value
			})
		}

		return translationEntity;
	}
}
